import React from 'react';
import ReactDOM from 'react-dom/client';

import { env } from '~/lib/env';
import { startMonitoring } from '~/modules/monitoring/startMonitoring';

import Shell from './Shell';

startMonitoring();

async function enableMocking() {
  if (import.meta.env.PROD) {
    return;
  }

  const { worker } = await import('./lib/__mocks__/browser');

  return worker.start({
    onUnhandledRequest: 'bypass',
  });
}

enableMocking().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <Shell localBrand={env('VITE_BRAND', false)} />
    </React.StrictMode>,
  );
});
